import { type ReactNode, useState } from 'react';
import { useTimeout } from 'usehooks-ts';
import LoadingLayout from '@/components/layouts/progress-layout/loading-layout';

interface Props {
  delay: number;
  className?: string;
  children: () => ReactNode;
}

export default function DelayedLayout({ delay, className, children }: Props) {
  const [isDelayed, setIsDelayed] = useState(false);

  useTimeout(() => setIsDelayed(true), delay);

  return (
    <LoadingLayout
      promise={!isDelayed}
      className={className}>
      {children}
    </LoadingLayout>
  );
}
